import type { BffOrganizationResourceReadApi } from '@ingenico/api-sdk-provisioning-private';
import type { IOrganization } from '../../models/organization.model';

export function mapGetOrganizationById(data: BffOrganizationResourceReadApi): IOrganization {
  return { ...data, parentOrganizationName: data.hierarchyMetadata.directParentOrganizationName };
}
